import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { JobOpening } from '../../models/job-opening.interface';

@Injectable({
  providedIn: 'root'
})
export class JoinUsService {

  constructor(private http: HttpClient) {}

  getJobs(): Observable<JobOpening[]> {
    return this.http.get<JobOpening[]>('assets/data/jobs.json');
  }

  getJobBySlug(slug: string): Observable<JobOpening | undefined> {
    const normalizedSlug =
      slug === 'vice-president-rj-international'
        ? 'vice-president-zumera-eweka'
        : slug;

    return this.http.get<JobOpening[]>('assets/data/jobs.json').pipe(
      map((jobs: JobOpening[]) => jobs.find(job => job.slug === normalizedSlug))
    );
  }
}
